import React from "react";
import Icon from "@ant-design/icons";
import { TrashRedSvg } from "../../assets/icons";

const TrashIcon = (props) => (
  <Icon
    component={TrashRedSvg}
    {...props}
  />
);

export const UserListHeader = ({
  actualSelectedCount,
  filteredUsersCount,
  onBulkDelete,
  leadSlot = null,
  heading = null,
  rightSlot = null,
}) => {
  return (
    <div className="min-h-[2.5rem] flex justify-between items-center mb-6">
      <div className="flex items-center gap-4">
        {/* Leftmost — back navigation on the deactivated view, which
            conventionally leads the content rather than trailing on the right. */}
        {leadSlot}
        {/* View heading — "N active users" / "N deactivated users", carrying
            the row count. */}
        {heading && (
          <div
            style={{ fontFamily: "Satoshi", fontWeight: 700, fontSize: "1.5rem" }}
          >
            {heading}
          </div>
        )}
        {actualSelectedCount > 0 && (
          <>
            <div
              className="text-sm text-gray-500 font-medium"
              style={{
                fontFamily: "Inter",
                fontSize: "14px",
                color: "#6B7280",
              }}
            >
              {actualSelectedCount}/{filteredUsersCount} users selected
            </div>
            <button
              onClick={onBulkDelete}
              className="flex items-center bg-[#fef6f6] gap-2 px-4 py-2 border-[#df0101] border-[2px] text-[#df0101] text-xs font-medium rounded-full transition-colors cursor-pointer"
            >
              <TrashIcon className="w-4 h-4" />
              Delete
            </button>
          </>
        )}
      </div>
      {/* Right slot — the single Active↔Deactivated entry point:
          a count-bearing "Deactivated N" chip on the active view, a
          "Back to active users" link on the deactivated view. */}
      {rightSlot}
    </div>
  );
};

